export default __webpack_public_path__ + "static/key-brain--green-5ea3f7f0e90c1f8e7a3d9797a00bbef2.webp";